import axios from "axios";

const apiStrapi = axios.create({
  baseURL: "https://campaign.irisnco.id",
});

export default apiStrapi;
